import { RoutingRuleListTableRowData } from '../types';
import { RowTextCell } from './RowTextCell';

interface NameCellProps {
    name: RoutingRuleListTableRowData['name'];
}

export const NameCell: React.FC<NameCellProps> = ({ name }) => <RowTextCell title={name} />;
